import { useState, useEffect } from 'react';
import { BREAKPOINTS } from '~/constant/constants';

export const useScreen = () => {
  const [width, setWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 0,
  );
  const [height, setHeight] = useState(
    typeof window !== 'undefined' ? window.innerHeight : 0,
  );

  useEffect(() => {
    const onResize = () => {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const screenType: 'mobile' | 'tablet' | 'desktop' | 'largeDesktop' =
    width <= BREAKPOINTS.mobile
      ? 'mobile'
      : width <= BREAKPOINTS.tablet
        ? 'tablet'
        : width <= BREAKPOINTS.desktop
          ? 'desktop'
          : 'largeDesktop';

  return { innerWidth: width, innerHeight: height, screenType };
};
